import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DenverPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      " Why should I select TekRevol for mobile app development in Denver?",
    answer: `<p>Our experienced team of developers, designers, and strategists mix local insights with global expertise, guaranteeing your app resounds with Denver's audience. We're dedicated to user-centric design, cutting-edge technology, and providing exceptional results.</p>`,
  },
  {
    question: "What industries do you focus on for app development in Denver?",
    answer: `<p>We cater to a broad range of industries, including E-commerce, Healthcare, Finance, Hospitality, and Entertainment. Our proficiency guarantees custom-made solutions for your business needs.</p>`,
  },
  {
    question: "What platforms do you craft apps for?",
    answer: `<p>We specialize in crafting apps for both Android and iOS platforms. Our developers are accomplished in developing native and cross-platform apps, guaranteeing maximum reach for your app.</p>`,
  },
  {
    question: " How do you confirm the security of my app and user data?",
    answer: `<p>Security is supreme. We apply industry best practices and ethics for data protection. Our team thoroughly tests the app for susceptibilities and guarantees robust security measures are in place.</p>`,
  },
  {
    question: "Can you help with app marketing?",
    answer: `<p>Absolutely. We provide mobile app marketing services to help your app gain prominence in the market. Our strategies include SEO (Search Engine Optimization), ASO (App Store Optimization), social media promotion, and targeted advertising.</p>`,
  },
  {
    question: "Do you deliver constant app maintenance and updates?",
    answer: `<p>Yes, we offer post-launch support, including regular updates, bug fixes, and feature improvements. Our goal is to ensure your app remains up-to-date and applicable in a rapidly developing tech landscape.</p>`,
  },
  {
    question: "How long does it take to create a mobile app in Denver?",
    answer: `<p>The timeline changes depending on the intricacy of the app and your detailed requirements. We'll offer you a clear project timeline during the early consultation.</p>`,
  },
  {
    question: "What is the cost of app development in Denver?",
    answer: `<p>The cost changes based on factors such as app intricacy, features, platforms, and design. The average cost for app development in Denver is $20,000 to $150,000 depending on the complexity of the application.</p>`,
  },
  {
    question: "Can you help convert my website into a mobile app?",
    answer: ` <p>Yes, we provide website-to-app conversion services. Our developers can develop mobile apps that imitate the functionality and design of your website, enhancing the user experience for mobile devices.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DenverPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
